import { Component, HostListener, inject, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { HisUiService } from '../../service/base/his-ui.service';
import { HisNotificationService } from '../../service/notifications/his-notification.service';
import { fromEvent, Subject, takeUntil } from 'rxjs';

/**
 * Komponente zum Abfangen und blockiren der Benutzung des Browser-Zurück-Buttons
 */
@Component({
    selector: 'his-browser-back-button-lock',
    template: `
    <span> </span>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HisBrowserBackButtonLockComponent implements OnInit, OnDestroy {
    private notificationService = inject(HisNotificationService);
    private hisUiService = inject(HisUiService);
    private unsubscriber: Subject<void> = new Subject<void>();

    /**
     * Verhindert die Möglichkeit den Browser-Back-Button zu verwenden
     */
    ngOnInit(): void {
        history.pushState(null, '', location.href);
        history.pushState(null, '', location.href);

        fromEvent(window, 'popstate')
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((_) => {
                history.pushState(null, '', location.href);
                if (location.pathname === window.location.pathname) {
                    history.pushState(null, '', location.href);
                    setTimeout(() => {
                        let warningMessageTitle = this.hisUiService.translate('cs.sys.notification.Notification.warningType');
                        let warningMessageText = this.hisUiService.translate('gui.dontUseBackBtnErrorMsg');
                        this.notificationService.clear();
                        this.notificationService.warn(warningMessageText, warningMessageTitle);
                    });
                }
            });
    }

    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }

}
